import ScheduledRemindersList from './ScheduledRemindersList';

export default ScheduledRemindersList;
